export default {
    baseStyle: {
        title: {
            fontWeight: {base: 'bold', lg: 'normal'},
            textTransform: 'none'
        }
    }
}
